var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"point"},[_c('div',{staticClass:"body"}),_c('div',{staticClass:"right"},[_c('div',{staticClass:"top"})])])}]

export { render, staticRenderFns }